import './QuickLinks.css';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import React, { useState } from 'react';

const QuickLinks = () => {
  const [open, setOpen] = useState(false);
  const [internalReferenceOpen, setInternalReferenceOpen] = useState(false);
  const [externalReferenceOpen, setExternalReferenceOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <div className="ql-container">
        <div className="ql-heading">QUICK LINKS</div>
        <div className="ql-content">
          <div className="entry-level">
            <div className="el-header">
              <div className="el-header-text">Entry Level</div>
              <img src={process.env.PUBLIC_URL + '/images/SAP/open-layers.svg'} alt="" className="el-header-icon" />
            </div>
            <div className="el-body">
              <div className="sp-body-row">
                <img src={process.env.PUBLIC_URL + '/images/SAP/feather.svg'} alt="" className="sp-body-icon" />
                <div className="sp-body-text">
                  <a href="https://atci.techexpressway.accenture.com/home" target="_blank">
                    Tech Expressway
                  </a>
                </div>
              </div>
              <div className="sp-body-row">
                <img src={process.env.PUBLIC_URL + '/images/SAP/feather.svg'} alt="" className="sp-body-icon" />
                <div className="sp-body-text">
                  <a href="https://atci.techleap.accenture.com/home" target="_blank">
                    Tech Leap
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="refrences">
            <div className="ref-header">
              <div className="ref-header-text">References</div>
              <img src={process.env.PUBLIC_URL + '/images/SAP/network.svg'} alt="" className="ref-header-icon" />
            </div>
            <div className="ref-body">
              <div className="sp-body-row">
                <img src={process.env.PUBLIC_URL + '/images/SAP/feather.svg'} alt="" className="sp-body-icon" />
                <div className="sp-body-text">
                  <p
                    onClick={() => {
                      setInternalReferenceOpen(true);
                    }}
                    className="ql-references-text"
                  >
                    Internal References
                  </p>
                  <Modal open={internalReferenceOpen} onClose={() => setInternalReferenceOpen(false)}>
                    <div className="internal-references-box">
                      <div className="ascend_heading">
                        <h3 className="references-header">Internal References </h3>
                        <img
                          src={process.env.PUBLIC_URL + '/images/SAP/ql_close.png'}
                          onClick={() => setInternalReferenceOpen(false)}
                          className="references-close-btn"
                          alt=""
                        />
                      </div>
                      <div>
                        <div className="acend_points">
                          <div>
                            <img
                              src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                              alt="Arrow"
                              className="references-attachment-icon"
                            />
                            <a
                              href="https://connectedlearning.accenture.com/topics/sap"
                              target="_blank"
                              rel="noreferrer"
                              className="ql-references-links"
                            >
                              SAP Learning Boards
                            </a>
                          </div>
                          <div>
                            <img
                              src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                              alt="Arrow"
                              className="references-attachment-icon"
                            />
                            <a
                              href="https://accenture.percipio.com/"
                              target="_blank"
                              rel="noreferrer"
                              className="ql-references-links"
                            >
                              Accenture Percipio
                            </a>
                          </div>
                          <div>
                            <img
                              src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                              alt="Arrow"
                              className="references-attachment-icon"
                            />
                            <a
                              href="https://atci.lkm.accenture.com/LKM-eCatalog/eCatalog"
                              target="_blank"
                              rel="noreferrer"
                              className="ql-references-links"
                            >
                              SAP eCatalogs
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Modal>
                </div>
              </div>
              <div className="sp-body-row">
                <img src={process.env.PUBLIC_URL + '/images/SAP/feather.svg'} alt="" className="sp-body-icon" />
                <div className="sp-body-text">
                  <p
                    onClick={() => {
                      setExternalReferenceOpen(true);
                    }}
                    className="ql-references-text"
                  >
                    External References
                  </p>
                  <Modal open={externalReferenceOpen} onClose={() => setExternalReferenceOpen(false)}>
                    <div className="external-references-box">
                      <div className="ascend_heading">
                        <h3 className="references-header">External References </h3>
                        <img
                          src={process.env.PUBLIC_URL + '/images/SAP/ql_close.png'}
                          onClick={() => setExternalReferenceOpen(false)}
                          className="references-close-btn"
                          alt=""
                        />
                      </div>
                      <div>
                        <div className="acend_points">
                          <div className="ql-external-references-1">
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://open.sap.com/"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                Open SAP
                              </a>
                            </div>
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://community.sap.com/"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                SAP Community
                              </a>
                            </div>
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://help.sap.com/viewer/index"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                SAP Help
                              </a>
                            </div>
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://blogs.sap.com/"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                SAP Blogs
                              </a>
                            </div>
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://training.sap.com/"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                SAP Training
                              </a>
                            </div>
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://www.sap.com/india/index.html?url_id=auto_hp_redirect_india"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                SAP India
                              </a>
                            </div>
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://www.ariba.com/"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                Ariba
                              </a>
                            </div>
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://wiki.scn.sap.com/wiki/#all-updates"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                SAP Wiki
                              </a>
                            </div>
                          </div>
                          <div className="ql-external-references-2">
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="http://www.sap.com/training-certification.html"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                SAP Training Certification
                              </a>
                            </div>
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://help.sap.com/learning-journeys/overview"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                SAP Learning Journeys
                              </a>
                            </div>
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://fioriappslibrary.hana.ondemand.com/sap/fix/externalViewer/#/home"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                SAP Fiori Apps Library
                              </a>
                            </div>
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://launchpad.support.sap.com/logout.html"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                SAP Launchpad Support
                              </a>
                            </div>
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://support.sap.com/en/my-support/users/welcome.html"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                SAP Support
                              </a>
                            </div>
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://www.youtube.com/saphanaacademy"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                SAP Hana Support
                              </a>
                            </div>
                            <div>
                              <img
                                src={process.env.PUBLIC_URL + '/images/SAP/ql_attachment.png'}
                                alt="Arrow"
                                className="references-attachment-icon"
                              />
                              <a
                                href="https://www.opentext.com/products-and-solutions/products/opentext-suite-for-sap/opentext-vendor-invoice-management-for-sap-solutions"
                                target="_blank"
                                rel="noreferrer"
                                className="ql-references-links"
                              >
                                Opentext
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Modal>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="special-programs">
            <div className="sp-header">
              <div className="sp-header-text">Special Programs</div>
              <img src={process.env.PUBLIC_URL + '/images/SAP/awesome-desktop.svg'} alt="" className="sp-header-icon" />
            </div>
            <div className="sp-body">
              <div className="sp-body-row">
                <img src={process.env.PUBLIC_URL + '/images/SAP/feather.svg'} alt="" className="sp-body-icon" />
                <div className="sp-body-text">
                  <a href="https://deepknowledge.accenture.com/home/sap-leader-series" target="_blank">
                    SAPQ for Leaders
                  </a>
                </div>
              </div>
              <div className="sp-body-row">
                <img src={process.env.PUBLIC_URL + '/images/SAP/feather.svg'} alt="" className="sp-body-icon" />
                <div className="sp-body-text">
                  <a href="https://atci.lkm.accenture.com/QuantumImpact/home" target="_blank">
                    Quantum Impact Program
                  </a>
                </div>
              </div>
              <div className="sp-body-row">
                <img src={process.env.PUBLIC_URL + '/images/SAP/feather.svg'} alt="" className="sp-body-icon" />
                <div className="sp-body-text">
                  <a onClick={handleOpen}>SAP Ascend</a>
                  <Modal
                    hideBackdrop
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="child-modal-title"
                    closeAfterTransition
                    aria-describedby="child-modal-description"
                  >
                    <Box className="ascend_box">
                      <div>
                        <div className="ascend_heading">
                          <h3 className="paramodel">SAP Ascend </h3>
                          <span className="close_btn_model" onClick={handleClose}>
                            Close
                          </span>
                        </div>
                        <hr />
                        <div>
                          <div>
                            <p className="SAP_AscendInfo">
                              SAP is a major business group in the Enterprise and Industry Technologies (E&IT) and our practice
                              helps our clients unlock incremental business value and enable the highest growth value
                              for Accenture by combining technology and industry excellence to create innovative
                              solutions. Our SAP practice is in high demand across many industries.
                              <br />
                              To help us increase and strengthen our SAP presence and provide our SAP practitioners with
                              a market edge, we are launching SAP Ascend, a nominations only based Certification drive.
                            </p>
                            <br />
                            <p>
                              For our SAP practitioners, this is a great chance to increase proficiency in various SAP
                              areas. The certifications in the drive cover the following areas:
                            </p>
                            <br />
                          </div>
                          <div className="acend_points">
                            <div>
                              <img src={process.env.PUBLIC_URL + '/images/SAP/Arrow.svg'} alt="Arrow" />
                              <span>Customer Experience (CX)</span>
                            </div>
                            <div>
                              <img src={process.env.PUBLIC_URL + '/images/SAP/Arrow.svg'} alt="Arrow" />
                              <span>Data</span>
                            </div>
                            <div>
                              <img src={process.env.PUBLIC_URL + '/images/SAP/Arrow.svg'} alt="Arrow" />
                              <span>Finance</span>
                            </div>
                            <div>
                              <img src={process.env.PUBLIC_URL + '/images/SAP/Arrow.svg'} alt="Arrow" />
                              <span>Information Lifecycle Management (ILM)</span>
                            </div>
                            <div>
                              <img src={process.env.PUBLIC_URL + '/images/SAP/Arrow.svg'} alt="Arrow" />
                              <span>Logistics & Supply Chain)</span>
                            </div>
                            <div>
                              <img src={process.env.PUBLIC_URL + '/images/SAP/Arrow.svg'} alt="Arrow" />
                              <span>Open Text</span>
                            </div>
                            <div>
                              <img src={process.env.PUBLIC_URL + '/images/SAP/Arrow.svg'} alt="Arrow" />
                              <span>Basis/HANA/J2C</span>
                            </div>
                            <div>
                              <img src={process.env.PUBLIC_URL + '/images/SAP/Arrow.svg'} alt="Arrow" />
                              <span>Governance, Risk, and Compliance (GRC) & Security</span>
                            </div>
                            <div>
                              <img src={process.env.PUBLIC_URL + '/images/SAP/Arrow.svg'} alt="Arrow" />
                              <span>SAP Solution Manager</span>
                            </div>
                            <div>
                              <img src={process.env.PUBLIC_URL + '/images/SAP/Arrow.svg'} alt="Arrow" />
                              <span>SuccessFactors</span>
                            </div>
                            <div>
                              <img src={process.env.PUBLIC_URL + '/images/SAP/Arrow.svg'} alt="Arrow" />
                              <span>Tech Dev</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Box>
                  </Modal>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
      {/* <div className="ql-other-link">
        Want to learn more about SAP? Request for training
      </div> */}
    </>
  );
};

export default QuickLinks;
